import * as React from 'react';
import { useDispatch } from 'react-redux';
import './Base.css';
const VerifyCheckStart = (props) => {
    const useState = React.useState;
    const dispatch = useDispatch();
    // Component State
    const [checkNumber, setCheckNumber] = useState("");
    const [verificationCode, setVerificationCode] = useState("");
    const submitData = (e) => {
        const data = {
            checkNumber: checkNumber,
            verificationCode: verificationCode,
            host: window.location.host
        };
        fetch(`api/validatecheck`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        })
            .then(response => response.json())
            .then(data => {
            dispatch({ type: 'RECEIVE_VERIFY_CHECK', data: data });
            if (data.siteDraftCheck.isAdopted) {
                dispatch({ type: 'GOTO_PROCESS_STATE', processState: "verificationAdopted" });
            }
            else {
                if (data.siteDraftCheck.isVerified) {
                    dispatch({ type: 'GOTO_PROCESS_STATE', processState: "underwriting" });
                }
                else {
                    dispatch({ type: 'GOTO_PROCESS_STATE', processState: "verificationFail" });
                }
            }
        });
        dispatch({ type: 'REQUEST_VERIFY_CHECK' });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("p", null, "Enter the check number and the verification code printed on the AutoCheck."),
        React.createElement("div", null,
            React.createElement("label", null, "Check Number"),
            React.createElement("input", { className: "form-control", name: "checkNumber", onChange: (ev) => setCheckNumber(ev.target.value) }),
            React.createElement("label", null, "Verification Code"),
            React.createElement("input", { className: "form-control", name: "verificationCode", onChange: (ev) => setVerificationCode(ev.target.value) }),
            React.createElement("div", { className: "button_container" },
                React.createElement("button", { className: "btn btn-primary", onClick: submitData }, "Submit")))));
};
export default VerifyCheckStart;
//# sourceMappingURL=VerifyCheckStart.js.map